export default __webpack_public_path__ + "static/media/after-effects.3c076652.svg";